export const SITE_MARKUP = `
<nav>
  <div class="nav-content">
    <div class="logo-wrap" style="display:flex; align-items:center; gap:10px; white-space:nowrap;">
      <img src="https://customer-assets-wrfwihn1.emergentagent.net/wingman/36a15b32-3e11-45f7-9097-6f8468f2ac94/attachments/978460cde0da4b32a626a6953cd90563_IMG_9157.PNG"
           style="height:36px; width:auto; mix-blend-mode: multiply; border-radius:4px;" alt="EvoriqGPT logo">
      <span style="font-weight:900; font-size:20px; letter-spacing:-0.02em; color:#000;">EvoriqGPT</span>
    </div>

    <div class="hidden md:flex gap-10 font-bold text-xs uppercase tracking-widest opacity-60">
      <a href="#portfolio" data-testid="nav-case-studies-link" style="color:#000; text-decoration:none;">Case Studies</a>
      <a href="#automation" data-testid="nav-operations-link" style="color:#000; text-decoration:none;">Operations</a>
      <a href="#pricing" data-testid="nav-pricing-link" style="color:#000; text-decoration:none;">Pricing</a>
    </div>
    <button data-testid="nav-signup-button" onclick="document.getElementById('pricing').scrollIntoView()" class="btn btn-blue" style="padding:12px 28px; font-size:14px;">Sign Up</button>
  </div>
</nav>

<section id="hero">
  <div class="content-wrap">
    <p style="color:var(--blue); font-weight:900; text-transform:uppercase; letter-spacing:4px; margin-bottom:20px; font-size:12px;">Scale Your Revenue With AI</p>
    <h1 class="h1 mb-6">Automation That<br>Evolves with Your Scale.</h1>
    <p class="p mx-auto mb-10 font-medium">Generate a free live website in seconds, automate high-pressure closing calls, and dispatch 1,500 daily SMS leads. We don't just build sites; we build engines.</p>

    <div class="gen-box">
      <input type="text" id="biz-input" data-testid="generator-input" maxlength="120" class="gen-input" placeholder="Enter business name to generate engine..." onkeydown="if(event.key==='Enter'){executeGenerator()}">
      <button class="gen-btn" id="gen-btn" data-testid="generator-submit-button" onclick="executeGenerator()">Generate Live Site</button>
    </div>

    <div id="preview-panel" data-testid="generator-preview-panel">
      <div id="loader-screen" style="padding:160px 20px; text-align:center;">
        <h2 class="h2 mb-4" id="loader-msg" data-testid="generator-loader-message">INITIALIZING NEURAL WEAVER...</h2>
        <div style="width:280px; height:8px; background:#eee; border-radius:20px; margin:0 auto; overflow:hidden;">
          <div id="p-bar" style="width:0%; height:100%; background:var(--blue); transition:0.3s linear;"></div>
        </div>
      </div>
      <iframe id="live-site-frame" data-testid="generator-preview-iframe" title="Generated website preview" style="width:100%; height:100%; border:none; display:none;"></iframe>
    </div>
  </div>
</section>

<section id="portfolio" style="background:#ffffff;">
  <div class="content-wrap">
    <div style="text-align:center; margin-bottom:80px;">
      <h2 class="h2 mb-4">Websites We've Done</h2>
      <p class="p mx-auto font-bold">Industrial-grade performance engines built for the world's most aggressive firms.</p>
    </div>
    <div style="display:grid; grid-template-columns: repeat(auto-fit, minmax(min(320px, 100%), 1fr)); gap:40px;">
      <div class="card">
        <img src="https://static.prod-images.emergentagent.com/jobs/36a15b32-3e11-45f7-9097-6f8468f2ac94/images/528cb6909b38f98769966cf1f1ea9aaf90ba328c9951d92af340020d83bb9185.jpeg" class="port-img" alt="Zack's Contractor OS">
        <h3 class="h3 mb-2">Zack's Contractor OS</h3>
        <p style="font-size:14px; color:var(--text-sec); margin-bottom:30px;">Cinematic build with integrated lead flow and industrial machinery automation.</p>
        <button data-testid="portfolio-similar-build-1" onclick="document.getElementById('pricing').scrollIntoView()" class="btn btn-blue w-full" style="padding:15px; font-size:14px;">Generate Similar Build</button>
      </div>
      <div class="card">
        <img src="https://static.prod-images.emergentagent.com/jobs/36a15b32-3e11-45f7-9097-6f8468f2ac94/images/703457e01d7384cd3c4e6d95a9a13ca26ea6ee6f30bcb675e125efbfc19c1e7b.jpeg" class="port-img" alt="Holly Medical Engine">
        <h3 class="h3 mb-2">Holly Medical Engine</h3>
        <p style="font-size:14px; color:var(--text-sec); margin-bottom:30px;">High-conversion patient care portal with 24/7 AI intake and scheduling.</p>
        <button data-testid="portfolio-similar-build-2" onclick="document.getElementById('pricing').scrollIntoView()" class="btn btn-blue w-full" style="padding:15px; font-size:14px;">Generate Similar Build</button>
      </div>
      <div class="card">
        <img src="https://static.prod-images.emergentagent.com/jobs/36a15b32-3e11-45f7-9097-6f8468f2ac94/images/43123e315f016d43c78c90bae5d593b1be1ea86be796861d6345aebd24cb1bab.jpeg" class="port-img" alt="Enterprise Logic Hub">
        <h3 class="h3 mb-2">Enterprise Logic Hub</h3>
        <p style="font-size:14px; color:var(--text-sec); margin-bottom:30px;">Internal control dashboard managing 10k+ leads with zero human oversight.</p>
        <button data-testid="portfolio-similar-build-3" onclick="document.getElementById('pricing').scrollIntoView()" class="btn btn-blue w-full" style="padding:15px; font-size:14px;">Generate Similar Build</button>
      </div>
    </div>
  </div>
</section>

<section id="intelligence" style="background:#fff; border-top:1px solid #eee;">
    <div class="wrap text-center">
        <div style="display:inline-flex; align-items:center; gap:10px; margin-bottom:20px;">
           <span style="width:10px; height:10px; background:var(--blue); border-radius:50%; display:inline-block; animation: pulse 2s infinite;"></span>
           <p style="font-weight:900; text-transform:uppercase; letter-spacing:2px; font-size:12px; color:var(--blue);">The Ultimate Intelligence Stack</p>
        </div>
        <h2 class="h2 mb-8"> фронт-End Power. <br>Frontier Intelligence.</h2>
        <p class="p mx-auto mb-12" style="font-weight:700; color:#000; font-size:22px;">
            We combine Claude Fable, GPT-4o, and every industry-leading AI model into one unified engine.
            Visitors get the absolute best intelligence on the planet, automated for their specific niche.
        </p>
        <div style="display:flex; justify-content:center; flex-wrap:wrap; gap:30px; opacity:0.5;">
            <div style="font-weight:900; font-size:18px;">CLAUDE FABLE</div>
            <div style="font-weight:900; font-size:18px;">GPT-4O</div>
            <div style="font-weight:900; font-size:18px;">GEMINI 2.0</div>
            <div style="font-weight:900; font-size:18px;">MISTRAL LARGE</div>
        </div>
    </div>
</section>

<section id="automation" style="background:#f9f9fb;">
  <div class="content-wrap">
    <div style="display:grid; grid-template-columns: repeat(auto-fit, minmax(min(320px, 100%), 1fr)); gap:80px; align-items:center;">
      <div>
        <h2 class="h2 mb-6">The Automation Forge</h2>
        <p class="p mb-8 font-bold">We don't design sites. We weave neural architecture that captures and closes leads 24/7.</p>
        <div style="display:flex; flex-direction:column; gap:30px;">
          <div style="display:flex; gap:20px; align-items:center;">
            <div style="width:50px; height:50px; background:var(--blue); border-radius:15px; color:#fff; display:flex; align-items:center; justify-content:center; font-weight:900; font-size:20px;">1</div>
            <p style="font-weight:800; font-size:18px;">1,500 Lead Daily SMS Blitz</p>
          </div>
          <div style="display:flex; gap:20px; align-items:center;">
            <div style="width:50px; height:50px; background:var(--blue); border-radius:15px; color:#fff; display:flex; align-items:center; justify-content:center; font-weight:900; font-size:20px;">2</div>
            <p style="font-weight:800; font-size:18px;">Lisa — AI Voice Closing Agents</p>
          </div>
          <div style="display:flex; gap:20px; align-items:center;">
            <div style="width:50px; height:50px; background:var(--blue); border-radius:15px; color:#fff; display:flex; align-items:center; justify-content:center; font-weight:900; font-size:20px;">3</div>
            <p style="font-weight:800; font-size:18px;">Automated GHL CRM Ops</p>
          </div>
        </div>
      </div>
      <div class="terminal" id="term-console" data-testid="terminal-console">
        <p style="color:var(--green); font-weight:bold;">> SYSTEM CORE ONLINE</p>
        <p style="color:#666;">> Awaiting User Command...</p>
      </div>
    </div>
  </div>
</section>

<section id="pricing">
    <div class="content-wrap text-center">
        <h2 class="h2 mb-12">One Price. Total Automation.</h2>
        <div style="max-width:600px; margin:0 auto;">
            <div class="card" style="border-width:3px; border-color:var(--green); background:rgba(0, 200, 83, 0.02); padding:60px 40px;">
                <p style="text-transform:uppercase; font-weight:900; font-size:14px; color:var(--green); margin-bottom:15px; letter-spacing:2px;">Everything Included</p>
                <p class="price-tag" style="font-size:82px; margin-bottom:10px;">$997</p>
                <p style="font-size:18px; font-weight:700; color:var(--text-sec); margin-bottom:40px;">One-Time Payment. Lifetime Access.</p>
                <ul style="text-align:left; margin-bottom:50px; font-weight:800; list-style:none;" class="space-y-5 text-lg">
                    <li style="display:flex; gap:15px;"><span>✓</span> Fully Automated Website for Your Niche</li>
                    <li style="display:flex; gap:15px;"><span>✓</span> 1,500 Lead Daily SMS Blitz Dispatch</li>
                    <li style="display:flex; gap:15px;"><span>✓</span> Lisa AI Voice Closing Agents Active</li>
                    <li style="display:flex; gap:15px;"><span>✓</span> Full GHL Native CRM &amp; Pipeline Integration</li>
                    <li style="display:flex; gap:15px;"><span>✓</span> Zero Monthly Fees. Forever.</li>
                </ul>
                <button data-testid="pricing-deploy-button" onclick="window.open('https://www.commas.com/checkout/1BXEGVH8mgBKgtv', '_blank')" class="btn" style="background:var(--green); color:#fff; width:100%; padding:24px; font-size:20px; box-shadow:0 20px 40px rgba(0,200,83,0.2);">Deploy My Industrial Engine</button>
                <p style="margin-top:20px; font-size:12px; color:#aaa; font-weight:700; text-transform:uppercase;">No hidden fees. No recurring costs.</p>
            </div>
        </div>
    </div>
</section>

<footer style="padding:80px 24px; border-top:1px solid #eee; text-align:center; background:#f5f5f5;">
  <div class="wrap">
    <div style="display:inline-flex; align-items:center; justify-content:center; gap:12px; margin-bottom:20px;">
      <img src="https://customer-assets-wrfwihn1.emergentagent.net/wingman/36a15b32-3e11-45f7-9097-6f8468f2ac94/attachments/978460cde0da4b32a626a6953cd90563_IMG_9157.PNG"
           style="height:48px; width:auto; mix-blend-mode: multiply; border-radius:4px;" alt="EvoriqGPT logo">
      <span style="font-weight:900; font-size:28px; letter-spacing:-0.03em; color:#000;">EvoriqGPT</span>
    </div>
    <p style="color:#888; font-size:16px; font-weight:700; margin-bottom:40px; letter-spacing:-0.01em;">Intelligence That Evolves With You.</p>
    <div style="display:flex; justify-content:center; gap:40px; font-weight:800; font-size:14px; text-transform:uppercase; letter-spacing:1px;">
      <a href="#" data-testid="footer-privacy-link" style="color:#000; text-decoration:none; opacity:0.6;">Privacy</a>
      <a href="#" data-testid="footer-terms-link" style="color:#000; text-decoration:none; opacity:0.6;">Terms</a>
      <a href="mailto:support@eco-sweeps.com" data-testid="footer-contact-link" style="color:#000; text-decoration:none; opacity:0.6;">Contact</a>
    </div>
  </div>
</footer>

<div id="lead-modal" style="position:fixed; inset:0; z-index:2000; display:none; align-items:center; justify-content:center; background:rgba(0,0,0,0.8); backdrop-filter:blur(15px);">
  <div class="bg-white p-12 rounded-[40px] max-w-md w-full relative mx-4">
    <button onclick="closeSignup()" style="position:absolute; top:30px; right:30px; font-size:32px; border:none; background:none; cursor:pointer; font-weight:bold;">&times;</button>
    <h2 class="h2 mb-3 text-center">Deploy Engine</h2>
    <p style="color:#777; text-align:center; font-size:16px; margin-bottom:35px; font-weight:600;">Enter your business details to deploy your core.</p>
    <form onsubmit="event.preventDefault(); window.location.href='https://www.commas.com/checkout/1BXEGVH8mgBKgtv';" style="display:flex; flex-direction:column; gap:18px;">
      <input type="text" placeholder="Business Name" required style="width:100%; padding:18px; border:2px solid #eee; border-radius:15px; outline:none; font-weight:700; font-size:16px;">
      <input type="email" placeholder="Work Email" required style="width:100%; padding:18px; border:2px solid #eee; border-radius:15px; outline:none; font-weight:700; font-size:16px;">
      <button type="submit" class="btn btn-blue" style="width:100%; padding:20px;">DEPLOY NOW</button>
    </form>
  </div>
</div>
`;
